import Papa from "papaparse";

export function mergeBulkImportErrors(localErrors = [], apiErrors = []) {
  return [
    ...localErrors.map((e) => ({
      email: e.email || "Unknown",
      error: e.error || e.message || "Unknown error",
      row: e.row,
    })),
    ...apiErrors.map((e) => ({
      email: e.email || "Unknown",
      error: e.error || e.message || "Unknown error",
      row: e.row,
    })),
  ];
}

export function groupBulkImportErrors(errors = []) {
  const groups = new Map();
  errors.forEach((item) => {
    const key = item.error || "Unknown error";
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(item);
  });
  return Array.from(groups.entries()).map(([error, items]) => ({ error, count: items.length, items }));
}

export function collectDuplicateImportErrors(rows = [], existingUsers = []) {
  const existingEmails = new Set(
    (existingUsers || [])
      .map((u) => String(u.email || "").trim().toLowerCase())
      .filter(Boolean),
  );
  const seenInBatch = new Map();
  const errors = [];

  rows.forEach((row, index) => {
    const email = String(row.email || "").trim().toLowerCase();
    if (!email) return;
    const rowNumber = index + 1;

    if (existingEmails.has(email)) {
      errors.push({ row: rowNumber, email, error: "User with this email already exists" });
      return;
    }
    if (seenInBatch.has(email)) {
      errors.push({ row: rowNumber, email, error: "Duplicate email in this import file" });
      return;
    }
    seenInBatch.set(email, rowNumber);
  });

  return errors;
}

export function downloadBulkImportErrorReport(errors = [], filenamePrefix = "bulk_import_errors") {
  const csv = Papa.unparse(
    errors.map((e) => ({
      Row: e.row != null ? e.row : "",
      Email: e.email || "",
      Error: e.error || "",
    })),
    { header: true },
  );
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${filenamePrefix}_${new Date().toISOString().slice(0, 10)}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
